import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ThemeComponent } from './theme/theme.component';
import { LayoutModule } from './theme/layouts/layout.module';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ScriptLoaderService } from "./_services/script-loader.service";
import { ThemeRoutingModule } from "./theme/theme-routing.module";
import { AuthModule } from "./auth/auth.module";
import { DataService } from './_services/data.service';
import { GenericHandlerService } from './_services/generic-handler.service';
import { KeycloakAuthService } from './auth/_services/keycloak-auth.service';
import { RbacService } from './auth/_services/rbac.service';
import { RbacInterceptor } from './auth/_services/rbac.interceptor';

export function initKeycloak(keycloakAuthService: KeycloakAuthService) {
    return () => keycloakAuthService.init();
}


@NgModule({
    declarations: [
        ThemeComponent,
        AppComponent,
    ],
    imports: [
        LayoutModule,
        BrowserModule,
        HttpClientModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        ThemeRoutingModule,
        AuthModule,
    ],
    providers: [
        ScriptLoaderService,
        DataService,
        GenericHandlerService,
        KeycloakAuthService,
        RbacService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: RbacInterceptor,
            multi: true
        },
        {
            provide: APP_INITIALIZER,
            useFactory: initKeycloak,
            deps: [KeycloakAuthService],
            multi: true
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
